import React, { useState } from 'react';
import "../CSS/Payer.css";
import bannerImg from "../Images/solutions/Payers/solution-payers-banner-image.png";
import bannerImgMob from "../Images/Mobile Images/solutions/Payers/solution-payers-banner-image-mobile.png";
import payersDividerImg from "../Images/solutions/Payers/payers-divider-image.png";
import payersDividerImgMob from "../Images/Mobile Images/solutions/Payers/payers-divider-image-mobile.png";
import peopleIcon from "../Images/services/people-icon.svg";
import processIcon from "../Images/services/process-icon.svg";
import resultsIcon from "../Images/services/results-icon.svg";
import { Link } from 'react-router-dom';

const Payer: React.FC = () => {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const buttonLabels = [
    'Member Engagement',
    'Claim & Benefits Management',
    'Risk Adjustment',
    'Utilization Management',
    'Recovery Audit Contractor (RAC) Services',
    'DME & HIT Claim Management',
    'HEDIS Review',
    'Home Health Care',
  ];
  const bulletData = [
    [
      'Outbound Member / Patient Engagement',
      'Care Coordination',
      'Health Coaching',
      'Care Management',
      'Remote Patient Monitoring',
      'Social Determinants of Health',
      'Health Risk Assessment Outreach',
    ],
    [
      'Medical Record Review',
      'Claims Documentation (claim, billed charges, benefit coverage)',
      'Claims Denials Prep',
      'Claims Adjudication Prep',
      'Post Service Appeals Prep',
      'Investigation of Billing Issues',
      'Management of Medical Services',
      'Claims-billed Charge Review',
      'Benefit Administration',
    ],
    [
      'Chart Retrieval',
      'Chart Abstraction/Coding',
      'Prospective, Concurrent, Retrospective',
    ],
    [
      'Intake & Patient Registration',
      'Network Coordination',
      'Clinical Medical Necessity Review',
      'Concurrent, prospective, retrospective',
      'Post-Decision Support',
      'Appeals & Grievances',
      'Quality of Care Audit'
    ],
    [
      'Readmission Prevention',
      'Clinical Review',
      'RAC Audit Admin Support',
    ],
    [
      'Medical Record Review',
      'Medical Necessity Review',
      'Medical Summary',
    ],
    [
      'Chart Abstraction',
      'Chart Retrieval',
      'Supplemental Data Audit',
      'STARS Outreach Campaigns',
      'MRRV Audit',
      'Quality of Care',
    ],
    [
      'Intake',
      'Oasis Management',
    ],
  ];

  return (
    <div className="payer-page">
      <div className="payer-hero">
        <div className="payer-hero-img" style={{ '--hero-bg': `url(${bannerImg})`, '--hero-bg-mob': `url(${bannerImgMob})`, backgroundImage: `url(${bannerImg})` } as React.CSSProperties}></div>
        <div className="payer-hero-content">
          <div className="payer-hero-subtitle">Optimized Clinical Operations for Payers</div>
          <div className="payer-hero-title">Achieve superior outcomes<br />at reduced costs</div>
          <div className="payer-hero-desc">Our dedicated expert teams efficiently scale your clinical operations to support sustainable growth.</div>
        </div>
      </div>
      <div className="hq-support-title-text">
        <div className="hq-support-title">High-Quality Support Services to Expand Your Clinical Workforce</div>
        <div className="hq-support-subtitle">Medwell360 provides expert resources across multiple clinical domains</div>
        <Link to="/contact-us" className="hq-support-contact-btn">Contact Us</Link>
      </div>
      <div className="hq-support-services">
        <div className="hq-support-services-left">
          {buttonLabels.map((label, idx) => (
            <button
              key={label}
              className={`hq-support-btn${selectedIdx === idx ? ' active' : ''}`}
              onClick={() => setSelectedIdx(idx)}
              type="button"
            >
              <span className={`hq-support-btn-num${selectedIdx === idx ? ' active' : ''}`}>
                {selectedIdx === idx ? (
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="16" r="16" fill="#21747a" />
                    <text x="16" y="22" textAnchor="middle" fontSize="18" fontWeight="700" fill="#fff">{idx + 1}</text>
                  </svg>
                ) : (
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="16" r="16" fill="#e6f2f3" />
                    <text x="16" y="22" textAnchor="middle" fontSize="18" fontWeight="700" fill="#21747a">{idx + 1}</text>
                  </svg>
                )}
              </span>
              <span className="hq-support-btn-label">{label}</span>
            </button>
          ))}
        </div>
        <div className="hq-support-services-right"
          onTouchStart={(e) => {
            const touchDown = e.touches[0].clientX;
            e.currentTarget.setAttribute('data-touch-start', touchDown.toString());
          }}
          onTouchMove={(e) => {
            const touchDown = e.currentTarget.getAttribute('data-touch-start');
            if (!touchDown) return;
            const currentTouch = e.touches[0].clientX;
            const diff = Number(touchDown) - currentTouch;
            if (diff > 5) {
              // Swipe Left -> Next
              setSelectedIdx((prev) => (prev + 1) % buttonLabels.length);
              e.currentTarget.removeAttribute('data-touch-start');
            } else if (diff < -5) {
              // Swipe Right -> Prev
              setSelectedIdx((prev) => (prev - 1 + buttonLabels.length) % buttonLabels.length);
              e.currentTarget.removeAttribute('data-touch-start');
            }
          }}
        >
          <div
            className="mobile-nav-arrow mobile-nav-prev"
            onClick={() => setSelectedIdx((prev) => (prev - 1 + buttonLabels.length) % buttonLabels.length)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </div>

          <div className="hq-support-right-content-wrapper">
            <h3>{buttonLabels[selectedIdx]}</h3>
            <ul>
              {bulletData[selectedIdx].map((item, i) => (
                <li key={i} className="hq-support-bullet">
                  <span className="hq-support-check">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="#1db13a" />
                      <path d="M7 13.5L11 17L17 9.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div
            className="mobile-nav-arrow mobile-nav-next"
            onClick={() => setSelectedIdx((prev) => (prev + 1) % buttonLabels.length)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </div>
      </div>
      <div className="payer-quality-metric">
        <div className="payer-quality-metric-heading">
          Quality Isn't Just a Metric—It's a Mission. Medwell360 Delivers Nothing Less.
        </div>
        <div className="payer-quality-metric-row">
          <div className="payer-quality-metric-item">
            <div className="payer-quality-metric-value">85%</div>
            <div className="payer-quality-metric-label">Nurse Retention Rate</div>
          </div>
          <div className="payer-quality-metric-item">
            <div className="payer-quality-metric-value">99%</div>
            <div className="payer-quality-metric-label">Quality & Productivity SLA Adherence</div>
          </div>
          <div className="payer-quality-metric-item">
            <div className="payer-quality-metric-value">40%</div>
            <div className="payer-quality-metric-label">Average Direct Labor Savings</div>
          </div>
        </div>
      </div>
      <div className="payer-challenges-section">
        <div className="payer-challenges-title">Understand Today's Healthcare Challenges</div>
        <div className="payer-challenges-cards">
          <div className="payer-challenge-card">
            <div className="payer-challenge-card-title">Rising Reimbursement Complexity</div>
            <div className="payer-challenge-card-desc">Navigating payer reimbursement has become increasingly complex, requiring expert clinical review and documentation by highly trained, credentialed professionals.</div>
          </div>
          <div className="payer-challenge-card">
            <div className="payer-challenge-card-title">Evolving Market and Regulatory Pressures</div>
            <div className="payer-challenge-card-desc">Healthcare organizations face growing demands for clinical expertise across business units, driven by shifting regulations and industry dynamics.</div>
          </div>
          <div className="payer-challenge-card">
            <div className="payer-challenge-card-title">Clinician Shortages Threaten Quality and Growth</div>
            <div className="payer-challenge-card-desc">Recruiting and retaining skilled clinicians is costly and time-intensive—making it difficult to scale operations without compromising quality.</div>
          </div>
        </div>
      </div>

      <div className="payer-fullwidth-image">
        <picture>
          <source media="(max-width: 1100px)" srcSet={payersDividerImgMob} />
          <img
            src={payersDividerImg}
            alt="Payers Divider"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </picture>
      </div>
      <div className="partner-with-us">
        <div className="partner-with-us-title">Partner with Us to Deliver Scalable, High-Quality Clinical Outcomes</div>
        <div className="partner-with-us-cards">
          <div className="partner-with-us-card">
            <div className="partner-with-us-icon" role="img" aria-label="People">
              <img src={peopleIcon} alt="People Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="partner-with-us-card-title">People</div>
            <ul className="partner-with-us-list">
              <li>Nurse retention rate exceeds 80% - well above industry norms</li>
              <li>Leadership stability: Average manager tenure of 6 years and team leader tenure of 4 years</li>
              <li>Experienced operational leadership from clinical subject matter experts</li>
            </ul>
          </div>
          <div className="partner-with-us-card">
            <div className="partner-with-us-icon" role="img" aria-label="Process">
              <img src={processIcon} alt="Process Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="partner-with-us-card-title">Process</div>
            <ul className="partner-with-us-list">
              <li>Operations span three <b>HITRUST- and URAC HUM-accredited</b> centers</li>
              <li>Service delivery powered by <b>embedded Six Sigma methodologies</b></li>
              <li>Proven ability to rapidly scale clinical teams while maintaining quality</li>
              <li><b>24/7 operational coverage</b> for high throughput and consistent performance</li>
            </ul>
          </div>
          <div className="partner-with-us-card">
            <div className="partner-with-us-icon" role="img" aria-label="Results">
              <img src={resultsIcon} alt="Results Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="partner-with-us-card-title">Results</div>
            <ul className="partner-with-us-list">
              <li><b>15% average reduction</b> in costly rework loops</li>
              <li><b>99% decision accuracy</b> in Utilization Management (UM)</li>
              <li><b>99% quality rating</b> in HEDIS medical record reviews</li>
              <li><b>99% SLA adherence</b> for quality and productivity across engagements</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payer; 